<template>
  <div class="login-mfa">
    <form class="" method="post" @submit.prevent="submit">
      <header-text
        :label="$t('account')"
        :title="$t('two_factor_authentication')"
      />

      <message v-if="type == 'sms'" type="info" class="message--white">{{
        $t("auth_sms")
      }}</message>
      <message v-if="type == 'totp'" type="info" class="message--white">{{
        $t("auth_app")
      }}</message>

      <field-input
        v-model="code"
        :label="$t('code')"
        name="code"
        :v="$v.code"
      />
      <r-button-submit :label="$t('continue')" color="white" />
      <required-label />
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    type: null
  },

  data() {
    return {
      code: null
    };
  },
  validations: {
    code: {
      required
    }
  },
  methods: {
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit("submitMfa", this.code);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-mfa {
  .labels {
    //   margin-top: 20px;
    justify-content: flex-end;
  }
}
</style>
